import type { RateUnit } from './types';

const OZ_PER_GALLON = 128;
const OZ_PER_POUND = 16;
const OZ_PER_PINT = 16;
const OZ_PER_QUART = 32;
const OZ_PER_OUNCE = 1;

const OZ_PER_UNIT: Record<RateUnit, number> = {
    'gal/ac': OZ_PER_GALLON,
    'lb/ac': OZ_PER_POUND,
    'oz/ac': OZ_PER_OUNCE,
    'pt/ac': OZ_PER_PINT,
    'qt/ac': OZ_PER_QUART
};

// Rate units that represent a volume per area (vs mass per area). Only these
// contribute to tank-volume displacement. 'lb/ac' is a dry-product mass rate.
const VOLUME_RATE_UNITS = new Set<RateUnit>(['gal/ac', 'oz/ac', 'pt/ac', 'qt/ac']);

export { OZ_PER_GALLON, OZ_PER_UNIT, VOLUME_RATE_UNITS };
